import { PlatformClient as n } from "@coveo/platform-client";
import { ActivitiesInternalResource as t } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as i } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AnswerResource as s } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as c } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as a } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as u } from "./resources/CaseAssistConfigstInternalResource.js";
import { ChunkInspectorResource as m } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as p } from "./resources/commerce/Commerce.js";
import { ConditionResource as f } from "./resources/ConditionResource.js";
import { CrawlingModuleInternalResource as l } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as y } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as g } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as I } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as R } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as k } from "./resources/ExtensionInternalResource.js";
import { HostedPagesInternalResource as h } from "./resources/HostedPagesInternalResource.js";
import { InAppWidgetResource as C } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as P } from "./resources/InsightPanelConfigsInternalResource.js";
import { IPXInterfaceExperimentalResource as S } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as d } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as v } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as z } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as x } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as A } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as w } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as M } from "./resources/NotificationEventResource.js";
import { OrganizationCustomerKeysResource as E } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as O } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationQuotasResource as D } from "./resources/OrganizationQuotasResource.js";
import { OrganizationHealthMonitoringResource as L } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationInternalResource as b } from "./resources/OrganizationInternalResource.js";
import { OrganizationMonitoringResource as G } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationSettingsResource as H } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as j } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as F } from "./resources/PipelineSettingsResource.js";
import { PrivateLicenseResource as K } from "./resources/PrivateLicenseResource.js";
import { PreviewResource as N } from "./resources/PreviewResource.js";
import { PrivilegesResource as Q } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as T } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as W } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as B } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as X } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchInterfacesInternalResource as q } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as J } from "./resources/SearchPagesInternalResource.js";
import { SecurityCacheInternalResource as U } from "./resources/SecurityCacheInternalResource.js";
import { SourcesInternalResource as V } from "./resources/SourcesInternalResource.js";
const Y = [
  { key: "activitiesInternal", resource: t },
  { key: "agentConfiguration", resource: i },
  { key: "answer", resource: s },
  { key: "automationFreezes", resource: c },
  { key: "batchAnswer", resource: a },
  { key: "caseAssistConfigsInternal", resource: u },
  { key: "chunkInspector", resource: m },
  { key: "commerce", resource: p },
  { key: "condition", resource: f },
  { key: "crawlingModuleInternal", resource: l },
  { key: "crgaDashboard", resource: y },
  { key: "dataService", resource: g },
  { key: "documentIdentity", resource: I },
  { key: "exportService", resource: R },
  { key: "extensionInternal", resource: k },
  { key: "inAppWidget", resource: C },
  { key: "insightPanelConfigsInternal", resource: P },
  { key: "hostedPagesInternal", resource: h },
  { key: "ipxInterfaceExperimental", resource: S },
  { key: "licenseInternal", resource: d },
  { key: "logicalIndexes", resource: v },
  { key: "mcpConfigurations", resource: z },
  { key: "mcpPipelines", resource: x },
  { key: "modelsInternal", resource: A },
  { key: "nextGenSearchPagesInternal", resource: w },
  { key: "notificationEvent", resource: M },
  { key: "organizationInternal", resource: b },
  { key: "organizationCustomerKeys", resource: E },
  { key: "organizationDefinition", resource: O },
  { key: "organizationQuotas", resource: D },
  { key: "organizationHealthMonitoring", resource: L },
  { key: "organizationMonitoring", resource: G },
  { key: "organizationSettings", resource: H },
  { key: "pipelineInternal", resource: j },
  { key: "pipelineSettings", resource: F },
  { key: "privateLicense", resource: K },
  { key: "preview", resource: N },
  { key: "privileges", resource: Q },
  { key: "projectInternal", resource: T },
  { key: "reportInternalResource", resource: W },
  { key: "salesforceSourceConfigurationInternal", resource: B },
  { key: "schemaServiceTemporary", resource: X },
  { key: "searchInterfacesInternal", resource: q },
  { key: "searchPagesInternal", resource: J },
  { key: "sourcesInternal", resource: V },
  { key: "securityCacheInternal", resource: U }
];
class Xe extends n {
  constructor(e) {
    super(e), Y.forEach(({ key: r, resource: o }) => {
      this[r] = new o(this.API, this.ServerlessAPI);
    });
  }
}
export {
  Xe as PrivatePlatformClient
};
//# sourceMappingURL=PrivatePlatformClient.js.map
